import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { API } from '@apps/api-interfaces';
import { environment } from '../../../environments/environment';
import { getCookie } from '@apps/tools';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
export class PostsService {
    constructor(http) {
        this.http = http;
    }
    getPosts(type) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = API.POSTS;
            const params = type ? { type } : {};
            const headers = {};
            if (getCookie('cid')) {
                headers['cid'] = getCookie('cid');
            }
            return yield this.http
                .get(url, {
                headers,
                params
            })
                .toPromise();
        });
    }
    getPost(slug) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${API.POSTS}/slug/${slug}`;
            return yield this.http.get(url).toPromise();
        });
    }
    // Aktualnosci z zl-backend (nowy portal). Wolane wylacznie w przegladarce
    // (effect ma guard SSR) - newsy nie sa prerenderowane.
    getNews(limit = 6) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const base = environment.contentApiUrl || '/zl-api';
            const url = `${base}/content/aktualnosci`;
            return yield this.http
                .get(url, { params: { limit: `${limit}` } })
                .pipe(map(items => (items || []).map(item => (Object.assign({}, item, { link: item.url || item.link })))), catchError(() => of([])))
                .toPromise();
        });
    }
}
